export type PartialSumTreeNode = {
  sum: number;
  minIndex: number;
  kids?: {
    left: PartialSumTreeNode;
    right: PartialSumTreeNode;
  };
};

export const constructSumTree = (arr: (PartialSumTreeNode)[], minIndex?: number): PartialSumTreeNode => {
  if (arr.length === 1) { return arr[0]; }

  const fullLength = arr.length;
  const halfLength = Math.round(arr.length / 2);
  minIndex = minIndex || 0;
  const midIndex = minIndex + halfLength;
  const left = constructSumTree(arr.slice(0, halfLength), minIndex);
  const right = constructSumTree(arr.slice(halfLength, fullLength), midIndex);
  return (
    {
      sum: left.sum + right.sum,
      minIndex,
      kids: {
        left,
        right,
      },
    });
};

export const incrementSumTree = (sumTree: PartialSumTreeNode, index: number, delta: number): PartialSumTreeNode => {
  if (!sumTree.kids) {
    return { ...sumTree, sum: sumTree.sum + delta };
  }
  return {
    ...sumTree,
    sum: sumTree.sum + delta,
    kids: {
      left: sumTree.kids.right.minIndex > index ? incrementSumTree(sumTree.kids.left, index, delta) : sumTree.kids.left,
      right: sumTree.kids.right.minIndex <= index ? incrementSumTree(sumTree.kids.right, index, delta) : sumTree.kids.right,
    },
  };
};

export const getSumTreeSum = (sumTree: PartialSumTreeNode, index: number): number => {
  if (!sumTree.kids && sumTree.minIndex > index) {
    return sumTree.sum;
  }
  if (!sumTree.kids) {
    return 0;
  }
  if (sumTree.kids.right.minIndex > index) {
    return getSumTreeSum(sumTree.kids.left, index);
  }
  return sumTree.kids.left.sum + getSumTreeSum(sumTree.kids.right, index);
};

export const getSumTreeMaxIndexLessThan = (sumTree: PartialSumTreeNode, limit: number): number => {
  if (!sumTree.kids) {
    return sumTree.minIndex;
  }
  if (sumTree.kids.left.sum >= limit) {
    return getSumTreeMaxIndexLessThan(sumTree.kids.left, limit);
  }
  return getSumTreeMaxIndexLessThan(sumTree.kids.right, limit - sumTree.kids.left.sum);
};
